import { render, staticRenderFns } from "./SegmentsTable.vue?vue&type=template&id=9ed24e7a&"
import script from "./SegmentsTable.vue?vue&type=script&lang=js&"
export * from "./SegmentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports